import React, { useState } from "react";
import "./About.css";
import bishoImage from "../bisho.png";

export default function About({ data }) {
  const [isPhotoZoomed, setIsPhotoZoomed] = useState(false);

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about__grid">
          <div className="about__text">
            <span className="section-label">01 — About</span>
            <h2 className="section-title">Who I Am</h2>
            {data.about.map((p, i) => (
              <p key={i} className="about__para">{p}</p>
            ))}
            <a href="#contact" className="btn btn--primary" style={{ marginTop: "2rem" }}>
              Let's Work Together
            </a>
          </div>

          <div className="about__visual">
            <div className="about__card">
              <img
                src={bishoImage}
                alt="Bishoy"
                className={`about__photo ${isPhotoZoomed ? "about__photo--zoomed" : ""}`}
                onClick={() => setIsPhotoZoomed(!isPhotoZoomed)}
                style={{ cursor: "pointer" }}
              />
              <div className="about__card-border" />
            </div>

            <div className="about__stat-box">
              <div className="about__stat">
                <span className="about__stat-num">5+</span>
                <span className="about__stat-lbl">Projects</span>
              </div>
              <div className="about__stat-divider" />
              <div className="about__stat">
                <span className="about__stat-num">3.5</span>
                <span className="about__stat-lbl">GPA</span>
              </div>
              <div className="about__stat-divider" />
              <div className="about__stat">
                <span className="about__stat-num">∞</span>
                <span className="about__stat-lbl">Curiosity</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
